













































































import { ExportField } from '@/data/models/export.model';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ExportModal extends Vue {

	fields: ExportField;
	
	constructor() {
		super();
		this.fields = new ExportField();
	}

	submit() {
		this.$emit('submit', this.fields);
	}
	
}
